export const desktopWidth = 560;
export const tabletWidth = 512;
export const CLASS_DETAILS_MODAL_NAME = 'classDetailsModal';
export const CLASS_ID_PARAM = 'classId';
export const SOURCE_PARAM = 'source';
